import React from "react";
import { Lock, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function AccessDenied() {
  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-black flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-6 flex justify-center">
          <div className="bg-red-500/10 p-4 rounded-full">
            <Lock className="w-12 h-12 text-red-400" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-2">Access Denied</h1>
        
        <p className="text-zinc-400 text-base mb-4">
          Your account doesn't have any roles assigned. Please contact your administrator to assign roles and permissions.
        </p>
        
        <p className="text-zinc-500 text-sm mb-6">
          Without assigned roles, you cannot access any pages in this application.
        </p>
        
        <Link to="/">
          <Button className="w-full bg-brand-500 hover:bg-brand-600 text-white">
            <Home className="w-4 h-4 mr-2" />
            Return Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
